export default {
  // 秒传接口
  check: {
    url: "/opc-operation-api/file/v1/check",
    method: "POST"
  },
  // 大文件分片合并
  complete: {
    url: "/opc-operation-api/file/v1/complete",
    method: "POST"
  },
  // 文件预上传
  prepare: {
    url: "/opc-operation-api/file/v1/prepare",
    method: "POST"
  },
  // 根据contenid获取url
  download: {
    url: "/opc-operation-api/file/v1/download",
    method: "POST"
  }
};
